import React, { useContext, useEffect, useState } from 'react';
import { ViewModels } from '../SidebarFormat';
import { FaWindowClose } from "react-icons/fa";
import { Card, CardBody } from "reactstrap";
import axios from 'axios';
import { getToken } from '../../auth/AuthService';
import { ApiContext } from '../apiContext';
import notify from '../../helper/Notify';
import { useLoader } from '../../helper/Loader';

export default function Permission({Modalclose, modalData, setModalData}) {

  const [permissions, setPermissions] = useState({});
  const [masterToggles, setMasterToggles] = useState({});
  const token = getToken();
   const {setIsLoader} = useLoader();
  const apiBaseUrl = window.API_CONFIG.All_Api.users;
   const {setData } = useContext(ApiContext);

 useEffect(() => {
  const initialPermissions = {};
  const initialToggles = {};

  ViewModels.forEach((item) => {
   const moduleKey = item.key || item.Href.replace(/^\/+/, '');
    const matchedPerm = modalData?.permission?.find(p => p.module === moduleKey);

    if (matchedPerm) {
      initialPermissions[moduleKey] = {
        Add: matchedPerm.Add || false,
        Edit: matchedPerm.Edit || false,
        Delete: matchedPerm.Delete || false,
      };
      initialToggles[moduleKey] = true;
    } else {
      initialPermissions[moduleKey] = { Add: false, Edit: false, Delete: false };
      initialToggles[moduleKey] = false;
    }
  });

  setPermissions(initialPermissions);
  setMasterToggles(initialToggles);
}, [modalData]);



 const updatePermissions = (updatedPermissions, updatedToggles = masterToggles) => {
  setPermissions(updatedPermissions);

  const filteredPermissions = Object.entries(updatedPermissions)
    .filter(([module]) => updatedToggles[module])
    .map(([module, perms]) => ({
      module,
      ...perms,
    }));

  setModalData((prev) => ({ ...prev, permission: filteredPermissions }));
};


// const handleToggleChange = (moduleKey, perm, value) => {
//   if (!masterToggles[moduleKey]) return;

//   const updatedPermissions = {
//     ...permissions,
//     [moduleKey]: {
//       ...(permissions[moduleKey] || {}),
//       [perm]: value,
//     },
//   };

//   updatePermissions(updatedPermissions);
// };


const handleMasterToggle = (moduleKey, isChecked) => {
  const updatedToggles = {
    ...masterToggles,
    [moduleKey]: isChecked,
  };
  setMasterToggles(updatedToggles);

  let updatedPermissions = { ...permissions };

  if (!isChecked) {
    updatedPermissions[moduleKey] = { Add: false, Edit: false, Delete: false };
  }

  updatePermissions(updatedPermissions, updatedToggles);
};

{

   if (!modalData) {
    return null;
  }

  const handleClear = () =>{
     setMasterToggles({})
     setPermissions({})
  }

  const handleSubmit = async (event) =>{
    event.preventDefault();
    setIsLoader(true)
    if(modalData){
    const updatedData = { ...modalData};
    try {
          const response = await axios.get(apiBaseUrl, {
            headers: {
              "x-access-token": token,
            },
          });

          const careerData = response.data?.data || [];
          const updatedCareerData = careerData.map((item) =>
            item.code === modalData.code ? { ...item, ...updatedData } : item
          );
          const duplicateItem = careerData.find(
            (item) =>
              item.name === modalData.name && item.code !== modalData.code
          );

          if (duplicateItem) {
            notify.error("Data is a duplicate and cannot be updated.");
            return;
          }
        
          const updateResponse = await axios.post(
            apiBaseUrl,
             updatedCareerData,
            {
              headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "x-access-token": token,
              },
            }
          );

          console.log("Data successfully updated:", updateResponse.data);
          if(updateResponse.data.success === true){
          setData((prevData) => ({
            ...prevData,
            users: updatedCareerData,
          }));
          Modalclose();
          notify.success(updateResponse.data.message);
        }
        else{
          notify.error(updateResponse.data.message);
        }
        } catch (error) {
          console.error("Error updating data:", error);
          notify.error(error.message);
        }
        finally{
      setIsLoader(false)
    }
    }
  }

  return (
    <>
    <div className="modal-wrapper"></div>
      <div className="modal-container">
        <div className="modal-head">
          <h1>Manage Permissions</h1>
          <div className="close-icon">
            <FaWindowClose onClick={Modalclose} />
          </div>
        </div>
        <div className="modal-body">
          <Card>
            <CardBody>
  <div className="container mt-4">
    <div className="row">
      {ViewModels.map((item, index) => {
        const moduleKey =
          item.key || item.Href.replace(/^\/+/, '');
        // const current = permissions[moduleKey] || {
        //   Add: false,
        //   Edit: false,
        //   Delete: false,
        // };
       
        const isMasterOn = masterToggles[moduleKey];

        return (
          <div className="col-md-6 col-lg-4 mb-4" key={moduleKey || index}>
            <div className="card shadow-sm h-100">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="d-flex align-items-center gap-2">
                    {item.Icon && (
                      <div className="text-primary fs-4">{item.Icon}</div>
                    )}
                    <h5 className="mb-0">{item.Title}</h5>
                  </div>
                  <div className="form-check form-switch m-0">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={isMasterOn}
                      onChange={(e) =>
                        handleMasterToggle(moduleKey, e.target.checked)
                      }
                    />
                  </div>
                </div>

                {/* <div className="row g-1">
                  {['Add', 'Edit', 'Delete'].map((perm) => (
                    <div className="col-4" key={perm}>
                      <div className="form-check d-flex align-items-center">
                        <input
                          className="form-check-input me-2"
                          type="checkbox"
                          checked={current[perm]}
                          disabled={!isMasterOn}
                          onChange={(e) =>
                            handleToggleChange(moduleKey, perm, e.target.checked)
                          }
                        />
                        <label className="form-check-label">{perm}</label>
                      </div>
                    </div>
                  ))}
                </div> */}
              </div>
            </div>
          </div>
        );
      })}
    </div>

    <div className="d-flex justify-content-end gap-2 mt-4">
      <button type="button" className="btn btn-warning" onClick={handleClear}>
        Clear
      </button>
      <button type="button" className="btn btn-primary" onClick={handleSubmit}>
        Submit
      </button>
    </div>
  </div>
  </CardBody>
   </Card>
        </div>
      </div>
      </>
);

}
}
